export default {
	add: 'إضافة موظف',

	tabs: {
		all: 'الكل',
		applicants: 'المتقدمين',
		temporaries: 'المؤقتين',
		currently: 'المثبتين',
		former: 'السابقين',
	},

	'default-buttons': {
		filterEmployee: 'فرز المتقدمين',
	},

	headers: {
		formDate: 'تاريخ الاستمارة',
		jobs: 'الوظائف المطلوبة',
		prevJob: 'الوظائف المطلوبة',
		academicDegrees: 'الشهادات',
		academicSpecifications: 'الاختصاص',
		language: 'اللغة',
		computer: 'مهارات الحاسوب',
		expertise: 'المهارات الاخرا',
		salary: 'الراتب',
		age: 'العمر',
	},

	filters: {
		NO: 'غير مهم',
		sex: 'الجنس',
		jobs: 'الوظيفة المطلوبة',
		prevJobs: 'الوظيفة السابقة',
		academic: 'المؤهلات العلمية',
		academicDegrees: 'الشهادات',
		academicSpecifications: 'الاختصاص',
		academicFinish: 'متخرج',
		language: 'اللغة',
		expertise: 'مهارات آخرى',
		languageLevel: 'المستوى',
		computer: 'المهارات الحاسوبية',
		computerLevel: 'المستوى',
		military: 'الخدمة الإلزامية',
		salary: 'الراتب',
		from: 'من',
		to: 'إلى',
		age: 'العمر',
		nightWork: 'العمل الليلي',
		extraTime: 'العمل الإضافي',
		relative: 'أقارب في الشركة',
	},
};
